<template>
  <transition name="fade">
    <div
      v-if="isVisible"
      class="loading-screen"
      data-test="producer-loadingScreen"
    >
      <lottie
        :height="150"
        :width="150"
        :options="options"
      />
    </div>
  </transition>
</template>

<script lang="js">
import Lottie from 'vue-lottie';

import hashyLoader from '../../assets/lottie/hashyAnimation.json';

export default {
  components: {
    Lottie,
  },

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isVisible: this.visible,
      options: {
        animationData: hashyLoader,
      },
    };
  },

  watch: {
    visible(isVisible) {
      clearTimeout(this.visibleTimeout);

      if (isVisible) {
        this.isVisible = isVisible;
      } else {
        // Delay hiding the loading screen a bit
        this.visibleTimeout = setTimeout(() => {
          this.isVisible = isVisible;
        }, 1e3);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.loading-screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1000;
  background: #222222;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  h3 {
    margin-top: 1rem;
    color: white;
    font-size: 24px;
    font-weight: bold;
  }
}

.fade-enter-from, .fade-leave-to {
  opacity: 0;
}

/* Target state for entering */
.fade-enter-to, .fade-leave-from {
  opacity: 1;
}

/* Transition */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s ease-in-out;
}
</style>
